export default {
  text: 'Abrir perfil de {{paymentGateway}}',
  text_generic: 'Abrir perfil de incorporación',
  toasts: {
    failed_to_create: 'Error al abrir el perfil de {{paymentGateway}}',
    link_copied: 'Enlace copiado al portapapeles',
    copy_failed: 'Error al copiar el enlace',
  },
};
